import React, { useRef } from 'react';
import { Button } from '../ui/button';
import { IoMdClose } from 'react-icons/io';
import { Loader2 } from 'lucide-react';

const WideSheet = (props: any) => {
  const {
    children,
    open,
    onCancel,
    onSave,
    title = 'Wide Sheet',
    subTitle,
    saveLabel = 'Save Item',
    cancelLabel = 'Cancel',
    saveDisabled = false,
    closeButtonDataQa,
    overlayDataQa,
    overlayStyle,
    sheetStyle,
    cancelButtonDataQa,
    saveButtonDataQa,
    saveButtonType = 'button',
    saveButtonForm,
    saveLoading = false,
    canSave = true,
  } = props;

  const wideSheetRef = useRef<any>(null);

  return (
    <>
      <div ref={wideSheetRef} className={`wide_sheet ${open ? 'active' : 'notActive'}`} style={sheetStyle}>
        <div className="wide_sheet_header_wrapper">
          <div className="wide_sheet_header">
            <span className="wide_sheet_header_title">{title}</span>
            {subTitle && <span className="wide_sheet_header_subtitle">{subTitle}</span>}
          </div>

          <div className="wide_sheet_header_close">
            <button
              className="x_button"
              type="button"
              onClick={() => !saveLoading && onCancel()}
              disabled={saveLoading}
              data-qa={closeButtonDataQa}
            >
              <IoMdClose fontSize={16} />
            </button>
          </div>
        </div>

        <div className="wide_sheet_body">
          <div className="p-4 md:p-6 space-y-4 md:space-y-6">{children}</div>
        </div>

        <div className="wide_sheet_actions">
          <div className="wide_sheet_button_container">
            <Button
              className="dark:hover:bg-input/50 dark:hover:border-input"
              variant={'outline'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (saveLoading) return;
                onCancel();
              }}
              type="button"
              disabled={saveLoading}
              data-qa={cancelButtonDataQa}
            >
              {cancelLabel}
            </Button>
          </div>

          {canSave && (
            <div className="wide_sheet_button_container">
              <Button
                variant={'default'}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (saveLoading) return;
                  onSave?.();
                }}
                type={saveButtonType}
                form={saveButtonForm}
                disabled={saveDisabled || saveLoading}
                data-qa={saveButtonDataQa}
              >
                {saveLoading && <Loader2 className="size-4 animate-spin" />}
                {saveLabel}
              </Button>
            </div>
          )}
        </div>
      </div>

      <div
        onClick={() => !saveLoading && onCancel()}
        className={`wide_sheet_overlay ${open ? 'active' : ''}`}
        data-qa={overlayDataQa}
        style={overlayStyle}
      />
    </>
  );
};

export default WideSheet;
